<div class="message-panel">
    @for (group of messages | async; track group.label) {
    <div>
        <rask-header size="3">
            {{group.label}}
        </rask-header>
        @for (message of group.messages; track message.message + i; let i = $index) {
        <rask-message-panel-item
            [maxNumOfRows]="maxNumOfRows"
            [item]="message"
            (anchorClick)="anchorClicked($event)">
        </rask-message-panel-item>
        }
    </div>
    }

    @if (toggleEnabled) {
    <div>
        <rask-header class="show-more" size="3" (click)="toggle()">
            {{toggleText}}
            <i
                class="far"
                [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </rask-header>
    </div>
    }
</div>